import { render, staticRenderFns } from "./tagsSetting.vue?vue&type=template&id=8f1eddec&scoped=true&"
import script from "./tagsSetting.vue?vue&type=script&lang=js&"
export * from "./tagsSetting.vue?vue&type=script&lang=js&"
import style0 from "./tagsSetting.vue?vue&type=style&index=0&id=8f1eddec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1eddec",
  null
  
)

export default component.exports